
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import ServicesSection from './components/ServicesSection';
import CompanyIntroduction from './components/CompanyIntroduction';
import CompanyValues from './components/CompanyValues';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <CompanyIntroduction />
      <ServicesSection />
      <CompanyValues />
      <TrustSection />
    </div>
  );
}
